import React from 'react';
interface ProgressRingProps {
  percentage: number;
  size?: number;
  strokeWidth?: number;
}
export function ProgressRing({
  percentage,
  size = 64,
  strokeWidth = 4
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - percentage / 100 * circumference;
  const getColor = () => {
    if (percentage === 100) return 'text-emerald-500';
    if (percentage >= 50) return 'text-blue-500';
    if (percentage > 0) return 'text-amber-500';
    return 'text-gray-300';
  };
  return <div className="relative inline-flex items-center justify-center" data-id="element-133">
      <svg width={size} height={size} className="transform -rotate-90" aria-hidden="true" data-id="element-134">
        {/* Background circle */}
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="currentColor" strokeWidth={strokeWidth} className="text-gray-100" data-id="element-135" />
        {/* Progress circle */}
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" className={`${getColor()} transition-all duration-500 ease-out`} data-id="element-136" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-137">
        <span className="text-sm font-semibold text-gray-700" aria-label={`${percentage}% complete`} data-id="element-138">
          {percentage}%
        </span>
      </div>
    </div>;
}